<template>
  <div>
    <validation-observer ref="deticketsprofileVO">
      <div>
        <validation-provider
          :mode="providerValidationMode"
          :rules="'deptRequired:1'"
          v-slot="{ errors: deptsErrors }"
          tag="div"
          class="mx-3 mb-3"
        >
          <chips-selection
            selected-items-title="Departamento(s) Seleccionado(s):"
            v-model="selectedDept"
            :errors="deptsErrors"
            :chips-config="chipConfig"
            @addingItem="addingDept"
          >
            <template #selectionInputs>
              <validation-observer ref="deptForm" disabled>
                <div class="form-group">
                  <validation-provider rules="required" v-slot="{ errors }">
                    <custom-drop-down
                      label="Departamento:"
                      v-model="tempSelectedDept"
                      fieldname="name"
                      fieldkey="id"
                      placeholder="Seleccione"
                      custom-error-msg="El departamento es requerido."
                      :error="errors[0]"
                      :options="deptsOptions"
                      :reduce="(o) => ({ id: o.id, name: o.name })"
                    />
                  </validation-provider>
                </div>
              </validation-observer>
            </template>
          </chips-selection>
        </validation-provider>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import applicationIds from '@/utils/constants/applicationIds';
import deticketsService from '@/services/detickets';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import { extend, ValidationObserver, ValidationProvider} from 'vee-validate';
import ChipsSelection from '@/components/common/ChipsSelection';

extend('deptRequired', {
  validate(selectedDepts, args) {
    return {
      required: true,
      valid: selectedDepts?.length >= args.length,
    };
  },
  computesRequired: true,
  params: ['length'],
  message: 'Favor seleccione un departamento.',
});

const ROLES_CHIP_UTILS = {
  CONFIG: [
    { labelText: 'Departamento:', valueProp: 'name' },
  ],
  VALIDATION: () => ({
    on: ['selectionChanged'],
  }),
};

export default {
  name: 'DETicketsProfile',
  components: {
    ChipsSelection,
    CustomDropDown,
    ValidationObserver,
    ValidationProvider
  },
  model: {
    prop: 'user',
    event: 'profile-change',
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      originalDeptsOptions: [],
      selectedDept: [],
      tempSelectedDept: null,
      profile: {},
      chipConfig: ROLES_CHIP_UTILS.CONFIG,
      providerValidationMode: ROLES_CHIP_UTILS.VALIDATION,
    };
  },
  computed: {
    deptsOptions() {
      const selectedIds = this.selectedDept?.map(x => x.id) ?? [];
      return this.originalDeptsOptions.filter(x => !selectedIds.includes(x.id));
    },
    inEditMode() {
      return !!this.profile.userId;
    },
    deTicketsRole() {
      let role = this.user.roles.find(
        (r) =>
          r.applicationId.toUpperCase() ==
          applicationIds.detickets.toUpperCase()
      );
      return role;
    },
  },
  watch: {
    selectedDept: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.user.deticketsInfo.depts = newValue?.map(x => x.id) ?? [];
      }
    }
  },
  async mounted() {
    await this.loadProfileData();

    //load subdepts
    const res = await deticketsService.getDepts();
    this.originalDeptsOptions = res;
  },
  methods: {
    async addingDept() {
      const valid = await this.$refs.deptForm.validate();
      if (!valid) return;

      const selection = {
        id: this.tempSelectedDept.id,
        name: this.tempSelectedDept.name,
      };

      this.tempSelectedDept = null;      
      this.$refs.deptForm.reset();

      return selection;
    },
    async loadProfileData() {
      if (
        this.user.profiles?.findIndex(
          (p) => p.applicationId == applicationIds.detickets
        ) == -1
      ) {
        let deticketsProfile = null;
        if (this.user.userId) {
          deticketsProfile = await deticketsService.getProfile(
            this.user.userId
          );
        }

        if (deticketsProfile) {
          this.user.profiles.push(deticketsProfile);
          this.profile = deticketsProfile;
          this.selectedDept = [...deticketsProfile.depts];
        } else {
          this.user.profiles.push(this.getEmptyProfile());
          this.profile = this.getEmptyProfile();
        }
      }
    },

    async validate() {
      return await this.$refs.deticketsprofileVO.validate();
    },

    getEmptyProfile() {
      let profile = {
        applicationId: applicationIds.detickets,
        userId: null,
        firstName: null,
        lastName1: null,
        lastName2: null,
        isDeleted: false,
        createsCasesOnlyForSelf: false,
        email: null,
        deptId: null,
        deptName: null
      };

      return profile;
    },

    async save() {
        this.profile.firstName = this.user.firstName;
        this.profile.lastName1 = this.user.paternalLastName;
        this.profile.lastName2 = this.user.maternalLastName;
        this.profile.isDeleted = false;
        this.profile.createsCasesOnlyForSelf = false;
        this.profile.email = this.user.email;
        this.profile.deptIds = this.selectedDept.map(x => x.id);
        this.profile.applicationId = applicationIds.detickets;
        this.profile.SSN = this.user.socialSecurityNumber;
        this.profile.IsActiveDirectoryUser = this.user.authenticationMode === '2'

      if (this.inEditMode) {
        await deticketsService.updateProfile(this.profile);
      } else {
        this.profile.userId = this.user.userId;
        await deticketsService.createUserProfile(this.profile);
      }
    },
  }
};
</script>

<style scoped></style>
